module.exports = __webpack_public_path__ + "img/fruit-tomatoes-190x100.88eb5595.jpg";